import React, { memo } from 'react';
import PropTypes from 'prop-types';
var ButtonAnchor = function ButtonAnchor(_ref) {
  var action = _ref.action,
    label = _ref.label;
  return /*#__PURE__*/React.createElement("a", {
    // eslint-disable-line jsx-a11y/anchor-is-valid
    role: "button",
    onClick: action,
    onKeyDown: action,
    tabIndex: "-1"
  }, label);
};
ButtonAnchor.propTypes = {
  action: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired
};
export default /*#__PURE__*/memo(ButtonAnchor);